// ================================页面性能上报=====================
/**
 * DNS查询耗时 ：domainLookupEnd - domainLookupStart    dnsTime
 * TCP链接耗时 ：connectEnd - connectStart
 * request请求耗时 ：responseEnd - responseStart
//  * 解析dom树耗时 ： domComplete - domInteractive
 * 白屏时间 ：responseStart - navigationStart
 * domready时间(用户可操作时间节点) ：domContentLoadedEventEnd - navigationStart
 * onload时间(总下载时间) ：loadEventEnd - navigationStart
 */
import KEWLSensors from './kewlSensors.js';

window.addEventListener(
  'load',
  function() {
    // 检测performace api
    if (
      this.window.KEWLSensors &&
      !window.performance &&
      window.performance.timing &&
      window.performance.getEntries
    ) {
      return
    }
    var fetchStart = performance.timing.fetchStart
    var navigationStart = performance.timing.navigationStart || fetchStart
    var domainLookupEnd = performance.timing.domainLookupEnd
    var domainLookupStart = performance.timing.domainLookupStart || fetchStart
    var connectEnd = performance.timing.connectEnd
    var connectStart = performance.timing.connectStart
    var responseEnd = performance.timing.responseEnd
    var responseStart = performance.timing.responseStart
    var domContentLoadedEventEnd = performance.timing.domContentLoadedEventEnd
    // var loadEventEnd = performance.timing.loadEventEnd;
    //kewlweb_performace:187 language:string dnstime:int64 onloadtime:int64 domreadytime:int64 tcptime:int64
    //requesttime:int64 whitescreentime:int64 entrieslist:string
    // 神策上报
    KEWLSensors.register('kewlweb_performance', {
      language: '',
      dnstime: 0,
      onloadtime: 0,
      domreadytime: 0,
      tcptime: 0,
      requesttime: 0,
      whitescreentime: 0,
      entrieslist: '',
      firstScreenOnloadTime: 0,
      fcp: 0
    });


    var timer = setInterval(function() {
      try {
        if (performance.timing.loadEventEnd !== 0) {
          var timing = performance.timing
          clearInterval(timer)
          // entrieslistJsonStr 的字符长度可能很长 目前仅抽取一个接口，一个脚本资源加载性能上报
          console.info(performance.getEntries())
          var entries = performance.getEntries()
          var PerformanceResourceTiming = []
          var perfEntries = []
          var perfFiledsEntries = []
          var scriptEntries = null
          var globalEntries = null
          for (var i = 0, len = entries.length; i < len; i++) {
            // 抽取一个liveme.com js脚本和kewlglobal脚本
            if (entries[i].entryType == 'resource' && entries[i].initiatorType == 'script') {
              if (entries[i].name.indexOf('kewlglobal.js') > -1) {
                globalEntries = entries[i]
              } else if (entries[i].name.indexOf('liveme.com') > -1) {
                scriptEntries = entries[i]
              }
            }
            // 拿到需要的脚本，跳出循环
            if (scriptEntries && globalEntries) {
              break;
            }
          }
          perfEntries.push(globalEntries)
          perfEntries.push(scriptEntries)
          for (var m = 0; m < perfEntries.length; m++) {
            if (perfEntries[m] && JSON.stringify(perfEntries[m]) != '{}') {
              var temp = {
                fetchStart: perfEntries[m].fetchStart,
                name: perfEntries[m].name,
                responseEnd: perfEntries[m].responseEnd
              }
            } else {
              continue
            }
            perfFiledsEntries.push(temp)
          }
          var entrieslistJsonStr =
            perfFiledsEntries.length > 0
              ? JSON.stringify(perfFiledsEntries)
              : '';
          // 把sw的控制器也上报
          if('serviceWorker' in navigator && navigator.serviceWorker.controller) {
            entrieslistJsonStr = `{sw-controller-scriptURL:${navigator.serviceWorker.controller.scriptURL}}${entrieslistJsonStr}`;
          }
          var utils = {
            getFcpTime: function getFcpTime() {
              /** 获取FCP时间 */
              var firstPaint = performance.getEntriesByName('first-contentful-paint') || [];

              if (firstPaint.length > 0) {
                return parseInt(firstPaint[0].startTime);
              }

              return 0;
            }
          };
          var domreadytime = domContentLoadedEventEnd > navigationStart ? domContentLoadedEventEnd - navigationStart : 0;
          var perfFiled = {
            language: navigator.language || '',
            dnstime: domainLookupEnd - domainLookupStart || 0,
            onloadtime: timing.loadEventEnd - navigationStart || 0, //点击区域     header   banner stream    tab    string
            domreadytime: domContentLoadedEventEnd > navigationStart ? domContentLoadedEventEnd - navigationStart : 0, //当前位置对应文案   例如主播名称   string
            tcptime: connectEnd - connectStart || 0, //点击直播位置   第几排  第几列  init
            requesttime: responseEnd - responseStart || 0, //点击直播的tab分类   stirng
            whitescreentime: responseStart - navigationStart || 0, //byte
            entrieslist: entrieslistJsonStr || '', //页面资源链接performace json 字符串
            firstScreenOnloadTime: domreadytime,
            fcp: utils.getFcpTime() // 获取FCP时间
          }
          console.info(perfFiled)
          KEWLSensors.track('kewlweb_performance',perfFiled);
        }
      } catch (error) {
        clearInterval(timer)
      }
    }, 1)
  },
  false
)
